<!-- TODO: A supprimer quand l'implémentation v10 sera terminée -->
<custom-frame [frame]="'utilisateursMessage'" [isTitleHidden]="true"></custom-frame>